/**
 * @generated SignedSource<<1a43ae805d43dbbe4d3a865aa6354c27>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraNumberFieldFormatStyle = "CURRENCY" | "DECIMAL" | "PERCENT" | "UNIT" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type number_issueFieldNumberReadviewFull_NumberReadView$data = {
  readonly formatConfig?: {
    readonly formatStyle: JiraNumberFieldFormatStyle | null | undefined;
    readonly formatUnit: string | null | undefined;
  } | null | undefined;
  readonly number: number | null | undefined;
  readonly " $fragmentType": "number_issueFieldNumberReadviewFull_NumberReadView";
};
export type number_issueFieldNumberReadviewFull_NumberReadView$key = {
  readonly " $data"?: number_issueFieldNumberReadviewFull_NumberReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"number_issueFieldNumberReadviewFull_NumberReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "number_issueFieldNumberReadviewFull_NumberReadView",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "number"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "JiraNumberFieldFormatConfig",
          "kind": "LinkedField",
          "name": "formatConfig",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "formatStyle"
            },
            {
              "kind": "ScalarField",
              "name": "formatUnit"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraNumberField"
};

(node as any).hash = "1c7d27c707db010357610ce0bf294301";

export default node;
